import { createReportReducer } from '../Reports/helpers';

import { CustomerTabCreditInfo } from './types';

const { reducer, actions } = createReportReducer<CustomerTabCreditInfo>('CustomerTabCredits');

export const {
  failed: failedCustomerTabCreditsInfo,
  request: requestCustomerTabCreditsInfo,
  succeeded: succeededCustomerTabCreditsInfo,
} = actions;

export default reducer;
